import SearchControls from './SearchControls';

export default SearchControls;
